'use client';
import React from 'react';
import Image from 'next/image';
import close from '@images/ico-close.png';
import closeHovered from '@images/ico-close-red.png';
import { useFullMenu } from './use-full-menu';

function FullMenuCloseButton({
  width = 30,
  height = 30,
}: {
  width?: number;
  height?: number;
}) {
  const { toggle } = useFullMenu();

  // 두 Image 는 hover 토글 장식 — 버튼 accessible name 은 aria-label 한 곳으로 통일.
  return (
    <button className="group" onClick={toggle} aria-label="Close">
      <Image
        className="group-hover:hidden"
        src={close}
        alt=""
        aria-hidden
        width={width}
        height={height}
      />
      <Image
        className="hidden group-hover:block"
        src={closeHovered}
        alt=""
        aria-hidden
        width={width}
        height={height}
      />
    </button>
  );
}

export default FullMenuCloseButton;
